module.exports = __webpack_public_path__ + "static/media/proj2_img7.38f9897f.jpg";